import { render } from "./UserInfoSectionTantoCmp.vue?vue&type=template&id=783193ad&scoped=true"
import script from "./UserInfoSectionTantoCmp.vue?vue&type=script&lang=js"
export * from "./UserInfoSectionTantoCmp.vue?vue&type=script&lang=js"

import "../css/UserInfoSectionTanto.css?vue&type=style&index=0&id=783193ad&scoped=true&lang=css"
import "./UserInfoSectionTantoCmp.vue?vue&type=style&index=1&id=783193ad&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src426064190/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/splats-mypage-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783193ad"]])

export default __exports__